module.exports = __webpack_public_path__ + "img/index4.b87aeadf.png";